import { State } from './types';
import {
  FETCH_ITEMS,
  SET_ITEMS,
  SET_COUNT,
  SET_PAGE,
  SET_LIMIT,
  SET_PAGE_COUNT,
} from './consts';
import convertArticlesFromApi from '@/helpers/convertArticlesFromApi';

const STORE_MODULE_NAME = 'blog';

const createStoreModule = (providers: any) => {
  const { $api } = providers;

  const state = (): State => ({
    title: 'Блог',
    metaKeywords: '',
    metaDescription: '',
    items: [],
    pageCount: 0,
    count: 0,
    limit: 9,
    page: 1,
  });

  const mutations = {
    [SET_ITEMS](state: State, items: Array<any>) {
      state.items = items;
    },

    [SET_COUNT](state: State, value: number) {
      state.count = value;
    },

    [SET_PAGE](state: State, value: number) {
      state.page = value;
    },

    [SET_LIMIT](state: State, value: number) {
      state.limit = value;
    },

    [SET_PAGE_COUNT](state: State) {
      state.pageCount = Math.ceil(state.count / state.limit) || 0;
    },
  };

  const actions = {
    async [FETCH_ITEMS]({ commit }: any, params: any) {
      try {
        const { filtered, page, data, limit } = (
          await $api.get('blogs/get', { params })
        ).data;
        commit(SET_ITEMS, data.map(convertArticlesFromApi));
        commit(SET_PAGE, Number(page));
        commit(SET_COUNT, Number(filtered ? filtered : data.length));
        commit(SET_LIMIT, Number(limit));
        commit(SET_PAGE_COUNT);
      } catch (e) {
        commit(SET_ITEMS, []);
        commit(SET_PAGE, 1);
        commit(SET_COUNT, 0);
        commit(SET_LIMIT, 9);
        commit(SET_PAGE_COUNT);
      }
    },
  };

  return {
    stateFactory: true,
    namespaced: true,
    namespace: STORE_MODULE_NAME,
    state,
    mutations,
    actions,
  };
};

export { FETCH_ITEMS, State, STORE_MODULE_NAME };
export default createStoreModule;



// WEBPACK FOOTER //
// ./src/pages/blog/list/store.ts